module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/bell-42a652683acf77dd0571008d484e6fa1.svg";